module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/admin/admin-datatable/admin-datatable.component.css
// module id = ./src/app/components/admin/admin-datatable/admin-datatable.component.css
// module chunks = main